import { render } from "./PasswordForget.vue?vue&type=template&id=2aedd113&scoped=true"
import script from "./PasswordForget.vue?vue&type=script&lang=js"
export * from "./PasswordForget.vue?vue&type=script&lang=js"

import "./PasswordForget.vue?vue&type=style&index=0&id=2aedd113&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aedd113"]])

export default __exports__